export const useStoriesPaginated = async function ({
  key,
  opts = {},
  perPage = { value: Infinity },
  page = { value: 1 },
}) {
  const { storyblok } = useStores()
  const storyapi = useStoryblokApi()

  const _key = computed(() => {
    return key || JSON.stringify(opts)
  })

  return useAsyncData(`${_key.value}_page${page}_per${perPage}`, async () => {
    const params = {
      ...opts,
      version: storyblok.version,
    }

    if (perPage.value < Infinity) {
      params.per_page = perPage.value
      params.page = page.value
    }

    return storyapi.get(`cdn/stories`, params)
  })
}

export default useStoriesPaginated
